<script>

import { Overlay } from '../../'

export default {
    name: 'UltimateOscillator',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Ultimate Oscillator - Combines three timeframes into one oscillator',
                preset: {
                    name: 'Ultimate Oscillator $period1 $period2 $period3',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#9c27b0',
                        bandColor: '#aaaaaa',
                        backColor: '#9c27b011',
                        upper: 70,
                        lower: 30
                    }
                }
            }
        },
        use_for() { return ['UltimateOscillator'] },
        calc() {
            return {
                props: {
                    period1: { def: 7, text: 'Period 1' },
                    period2: { def: 14, text: 'Period 2' },
                    period3: { def: 28, text: 'Period 3' }
                },
                conf: { renderer: 'Range' },
                update: `
                    let prior = Number.isFinite(close[1]) ? close[1] : close[0]
                    let pressure = ts(close[0] - Math.min(low[0], prior))
                    let range = ts(Math.max(high[0], prior) - Math.min(low[0], prior))
                    let shortRange = sum(range, period1)[0]
                    let mediumRange = sum(range, period2)[0]
                    let longRange = sum(range, period3)[0]
                    let first = shortRange ? sum(pressure, period1)[0] / shortRange : 0
                    let second = mediumRange ? sum(pressure, period2)[0] / mediumRange : 0
                    let third = longRange ? sum(pressure, period3)[0] / longRange : 0
                    return 100 * (4 * first + 2 * second + third) / 7
                `
            }
        }
    }
}
</script>
